export type Unit =
  | 'None'
  | 'BoolValue'
  | 'Integer'
  | 'Percent'
  | 'Meter'
  | 'Centimeter'
  | 'Millimeter'
  | 'Kilometer'
  | 'SquareMeter'
  | 'Angle'
  | 'Second'
  | 'Minute'
  | 'Hour'
  | 'Day'
  | 'Gram'
  | 'Kilogram'
  | 'Liter'
  | 'CubicMeter'
  | 'Newton'
  | 'Joule'
  | 'GramsPerMinute'
  | 'Milliliter'
  | 'MillilitersPerSecond'
  | 'MillimeterPerSecond'
  | 'CentimeterPerSecond'
  | 'MeterPerSecond'
  | 'Micrometer';
